import React from "react";
import { Typography, Alert } from "antd";
import ImageWithDescription from "../../Components/ImageWithDescription";
const { Title } = Typography;

export const ReleaseChannels = () => {
  return (
    <div style={{ maxWidth: 900, background: "#ffffff0d", padding: 30 }}>
      <Title>Installing beta and alpha releases</Title>
      <Alert
        type="info"
        showIcon
        message="All new Hero Zone features and games are first released as alpha and beta versions. These versions are not yet ready for production use and may contain bugs or issues, especially in the alpha releases."
      />
      <br />
      <br />
      <section>
        <ol>
          <li>
            Select the Beta Release Channel in the launcher advanced settings
            <ImageWithDescription
              width={800}
              src="/images/manual/ReleaseChannels/Beta1.jpg"
              description="Select beta release channel"
            />
          </li>
          <li>
            If a launcher update is available, a pop up will appear. Click on
            Update. Wait until the download finishes and the launcher has
            restarted.
            <ImageWithDescription
              width={400}
              src="/images/manual/ReleaseChannels/Beta2.jpg"
              description="Download launcher update"
            />
          </li>
          <li>
            Click on the &quot;Download Games&quot; button in the launcher
            settings.
            <ImageWithDescription
              width={800}
              src="/images/manual/ReleaseChannels/Beta3.jpg"
              description="Download game update 1"
            />
          </li>
          <li>
            If a game update is available, it will appear as the desired
            version. Start the download.
            <ImageWithDescription
              width={800}
              src="/images/manual/ReleaseChannels/Beta4.jpg"
              description="Download game update 2"
            />
          </li>
          <li>
            After downloading a game update you will need to reinstall the games
            on your headsets. Click on the &quot;Install Games&quot; button in
            the launcher settings.
            <ImageWithDescription
              width={800}
              src="/images/manual/ReleaseChannels/Beta5.jpg"
              description="Install games"
            />
          </li>
        </ol>
      </section>
      <section>
        <Alert
          type="info"
          showIcon
          message="If you've downloaded an alpha or beta release and want to switch back to the regular release, repeat the above steps but select the stable release channel instead."
        />
      </section>
    </div>
  );
};
